import Dictionary from '@inqool/uas-web-core/es/components/app/Dictionary';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { compose, withProps, onlyUpdateForKeys, setDisplayName } from 'recompose';
import { withRouter } from 'react-router-dom';

import { withClassname } from '@components/hoc/withClassname';
import * as React from 'react';
import { InventoryCardsForm } from '@modules/inventoryCards/InventoryCardsForm';
import { withAdditionalProps } from '@components/hoc/withAdditionalProps';
import { withColumns } from '@components/hoc/withColumns';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';
import { ColumnManager } from '@modules/columnSettings/ColumnManager';

export const inventoryCardsUrl = '/metropolis/api/wa/cards';
export const inventoryCardsLabel = 'Skladové karty';
export const inventoryCardsPath = '/warehouses/inventory-cards';
export const inventoryCardsGridName = 'InventoryCardsGrid';
export const InventoryCardsGrid = compose(
  withRouter,
  setDisplayName(inventoryCardsGridName),
  onlyUpdateForKeys(['url', 'location']),
  breadcrumbs([{ label: inventoryCardsLabel }]),
  withColumns(Agenda.INVENTORY_CARDS),
  withProps(({ columns }) => ({
    name: inventoryCardsGridName,
    url: inventoryCardsUrl,
    Form: InventoryCardsForm,
    dialog: false,
    gridProps: {
      columns,
      filterRow: true,
      showCheckboxes: true,
      deleting: true,
      filtering: true,
      locale: 'cz',
      adding: true,
      pageSize: 50,
      version: 3,
      ActionBar: () => <ColumnManager agenda={Agenda.INVENTORY_CARDS} />
    }
  })),
  withAdditionalProps,
  withClassname({ className: 'mp-grid' })
)(Dictionary);



// WEBPACK FOOTER //
// ./src/modules/inventoryCards/InventoryCardsGrid.tsx